/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePublicMemoDto
 */
export interface CreatePublicMemoDto {
    /**
     * 
     * @type {string}
     * @memberof CreatePublicMemoDto
     */
    enSubjectType: CreatePublicMemoDtoEnSubjectTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePublicMemoDto
     */
    subjectId: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePublicMemoDto
     */
    content: string;
}

export function CreatePublicMemoDtoFromJSON(json: any): CreatePublicMemoDto {
    return CreatePublicMemoDtoFromJSONTyped(json, false);
}

export function CreatePublicMemoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePublicMemoDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enSubjectType': json['enSubjectType'],
        'subjectId': json['subjectId'],
        'content': json['content'],
    };
}

export function CreatePublicMemoDtoToJSON(value?: CreatePublicMemoDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enSubjectType': value.enSubjectType,
        'subjectId': value.subjectId,
        'content': value.content,
    };
}

/**
* @export
* @enum {string}
*/
export enum CreatePublicMemoDtoEnSubjectTypeEnum {
    Kontrola = 'kontrola',
    PobranieProbek = 'pobranie_probek',
    BadanieProbek = 'badanie_probek',
    Postepowanie = 'postepowanie',
    Pak = 'pak',
    Kwz = 'kwz'
}


